module.exports = __webpack_public_path__ + "img/EvaSchilling_140x140_rund.bf640bcf.jpg";